// extracted by mini-css-extract-plugin
export default {"header":"LinkDetails_header__Arr1O"};